import * as React from 'react'
import { useModalContext } from '../modal'
import cls from 'classnames'
import type * as Polymorphic from '../../../../react-utils/polymorphic'
import styles from './modal-body.module.css'

export interface ModalBodyProps extends React.HTMLProps<any> {}

/**
 * ModalBody
 *
 * React component that houses the main content of the modal.
 *
 */
export const ModalBody = React.forwardRef((props, ref) => {
  const { className, ...rest } = props
  const { bodyId, setBodyMounted } = useModalContext()

  /**
   * Notify us if this component was rendered or used
   * so we can append `aria-describedby` automatically
   */
  React.useEffect(() => {
    setBodyMounted(true)
    return () => setBodyMounted(false)
  }, [setBodyMounted])

  const _className = cls(styles.paypal_modal__body, className)

  return <div ref={ref as any} className={_className} id={bodyId} {...rest} />
}) as Polymorphic.ForwardRefComponent<'div', ModalBodyProps>

ModalBody.displayName = 'ModalBody'
